import { render, staticRenderFns } from "./HandPaper.vue?vue&type=template&id=2132df8d&scoped=true&"
import script from "./HandPaper.vue?vue&type=script&lang=js&"
export * from "./HandPaper.vue?vue&type=script&lang=js&"
import style0 from "./HandPaper.vue?vue&type=style&index=0&id=2132df8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2132df8d",
  null
  
)

export default component.exports